var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowFatLinesUp = function SvgIconArrowFatLinesUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.293 1.543a1 1 0 0 1 1.414 0l9 9A1 1 0 0 1 21 12.25h-3.5v2a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1v-2H3a1 1 0 0 1-.707-1.707zM5.414 10.25H7.5a1 1 0 0 1 1 1v2h7v-2a1 1 0 0 1 1-1h2.086L12 3.664z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 17.25a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2h-9a1 1 0 0 1-1-1M6.5 20.25a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2h-9a1 1 0 0 1-1-1"
  }))));
};
export default SvgIconArrowFatLinesUp;